import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import * as IdKey from "short-uuid";
import { Tooltip, Grid } from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditIcon from "@material-ui/icons/Edit";
import { permissionsConstans } from "../../constansPermissions";
import EditClausesContracts from "./editClausesContracts";
import { withStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Utils from "../../utils/utils";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  rootGrid: {
    flexGrow: 1,
  },
  heading: {
    fontSize: theme.typography.pxToRem(12),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.text.secondary,
  },
  icon: {
    verticalAlign: "bottom",
    height: 20,
    width: 20,
  },
  iconEvent: {
    color: "#666666",
    cursor: "pointer",
    height: 18,
    width: 18,
  },
  details: {
    alignItems: "center",
    backgroundColor: "#EEFBFF",
  },
  column: {
    flexBasis: "100%",
  },
  columnEvent: {
    paddingLeft: "20px",
    flexBasis: "33.33%",
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 2),
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

export default function DetailedTable({
  headers,
  data,
  reset,
  setMessage,
  message,
}) {
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const classes = useStyles();
  const id = IdKey.generate();

  const validationPermission = () => {
    const state = JSON.parse(localStorage.getItem("state"));
    const module = state?.permissions.find((x) => x.code === "FOR_CLA_CON");
    if (
      module?.functionalities?.some(
        (x) => x === permissionsConstans.FOR_CLA_CON_EDITAR
      )
    ) {
      return (
        <div className={classes.columnEvent}>
          <Tooltip title="Editar" arrow placement="top">
            <EditIcon
              style={{ fontSize: 40, pointerEvents: "auto" }}
              onFocus={(event) => event.stopPropagation()}
              onClick={() => {
                setOpenModalEdit(true);
              }}
              className={classes.iconEvent}
            />
          </Tooltip>
        </div>
      );
    }
  };
  const getValueByKey = (header) => {
    if (header.field === "creationDate")
      return data?.creationDate ? data?.creationDate.split(" ")[0] : "";

    return !!data[header.field] ? data[header.field] : "";
  };

  const stateFieldEdit = (x) => setOpenModalEdit(x);

  const FlippedOrderExpansionPanelSummary = withStyles({
    root: {
      flexDirection: "row-reverse",
    },
  })(AccordionSummary);
  FlippedOrderExpansionPanelSummary.defaultProps = {
    IconButtonProps: { edge: "start" },
  };

  return (
    <div className={classes.root}>
      <Accordion
        style={{
          borderLeftStyle: "solid",
          borderLeftColor: "#F8DF13",
          marginTop: "10px",
        }}
      >
        <FlippedOrderExpansionPanelSummary
          aria-controls="panel1c-content"
          id={id}
          expandIcon={<ExpandMoreIcon style={{ pointerEvents: "auto" }} />}
          style={{ pointerEvents: "none" }}
        >
          {headers.initialHeaders.map((header) => (
            <div className={classes.column}>
              <Typography className={classes.heading}>
                {header.title}
              </Typography>

              <Typography className={classes.secondaryHeading}>
                {getValueByKey(header)}
              </Typography>
            </div>
          ))}

          <Tooltip title="Ver detalle" arrow placement="top">
            <VisibilityIcon
              style={{ fontSize: 40, pointerEvents: "auto" }}
              className={classes.iconEvent}
              onClick={() => {
                setOpenModalEdit(false);
              }}
            />
          </Tooltip>

          {validationPermission()}
        </FlippedOrderExpansionPanelSummary>

        <AccordionDetails className={classes.details}>
          <div className={classes.rootGrid}>
            {openModalEdit ? (
              <EditClausesContracts
                data={data}
                reset={reset}
                closeOpenEdit={stateFieldEdit}
                setMessage={setMessage}
                message={message}
              />
            ) : (
              <div className={classes.rootGrid}>
                <Grid
                  container
                  spacing={3}
                  style={{ padding: "0px 100px 0px 40px" }}
                >
                  {headers.otherHeaders.map((header, index) => (
                    <Grid item xs={12} key={index}>
                      <Typography className={classes.heading}>
                        {header.title}
                      </Typography>

                      <Typography className={classes.secondaryHeading}>
                        {Utils.replaceTextDynamicClauses(getValueByKey(header))}
                      </Typography>
                    </Grid>
                  ))}
                </Grid>
              </div>
            )}
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
